import { LanguageService } from 'services/languageService';
import { httpClient, httpConfig } from 'utils/httpClient';
const URL = process.env.REACT_APP_API_URL;

export const getClusterInfoVL = async (
  isLog: boolean,
  gid: string,
  layerId: number
) => {
  const url = `${URL}/api/${isLog ? 'pv-' : ''}getlayerpoint`;
  const lang = LanguageService.getLanguage();
  const params = { gid, lang, layer: String(layerId) };
  const res = await httpClient.post(
    url,
    new URLSearchParams(params),
    httpConfig
  );

  return { gid, info: res.data.data };
};
